import React, {useEffect} from 'react';
import { usePreference } from '../../Data/Preference';
import Button from '../Button/Button';
import { deviceIsMd } from '../../Services/helpers';

const StretchBtn = ({pref}) => {
    const [expand, setExpand] = usePreference(pref, false);

    useEffect(() => {
        document.getElementById('root').className = expand ? 'stretched' : 'not-stretched';

        return () => {
            document.getElementById('root').className = 'not-stretched';
        }
    }, [expand]);

    return <Button
        icon={expand ? 'ArrowsDiagonalIn' : 'ArrowsDiagonalOut'}
        onClick={() => setExpand(!expand)}
        size="md"
        className="mr-2"
        zeroMargin
        noShadow
        hide={!deviceIsMd()}
    />
}

export default StretchBtn;